import { useState } from "react";
import { LogOut, Plane, Settings } from "lucide-react";
import { Link } from "react-router-dom";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useAuth } from "@/hooks/useAuth";
import { SettingsDialog } from "@/components/settings/SettingsDialog";

export const UserMenu = () => {
  const { user, logout } = useAuth();
  const [settings, setSettings] = useState(false);
  if (!user) return null;
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className="w-9 h-9 shrink-0 rounded-full overflow-hidden ring-2 ring-white/10 hover:ring-emerald-400/60 transition-shadow bg-[#1C2536] grid place-items-center font-display font-semibold" data-testid="user-menu-button" aria-label="Account">
            {user.picture ? <img src={user.picture} alt="" className="w-full h-full object-cover" referrerPolicy="no-referrer" /> : user.name[0]}
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuLabel>
            <p className="font-medium truncate" data-testid="user-menu-name">{user.name}</p>
            <p className="text-xs text-slate-400 font-normal truncate">{user.email}</p>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          {user.is_admin && <DropdownMenuItem asChild data-testid="admin-trips-link"><Link to="/admin"><Plane size={14} /> Trip requests</Link></DropdownMenuItem>}
          <DropdownMenuItem onSelect={() => setSettings(true)} data-testid="settings-menu-item"><Settings size={14} /> Settings</DropdownMenuItem>
          <DropdownMenuItem onClick={logout} data-testid="logout-button"><LogOut size={14} /> Sign out</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <SettingsDialog open={settings} onOpenChange={setSettings} />
    </>
  );
};
